import { gerarUrl } from "../../../utilities/utils/Pageable";
import AuthService from "../../intranet/auth/auth_service";

export default class EventService extends AuthService {
  constructor() {
    super("evento");
  }

  search(queryParams) {
    const params = gerarUrl(queryParams);
    return this.execute("GET", `/buscar?${params}`).then((res) => res.data);
  }

  findAllEvents(queryParams){
    const params = gerarUrl(queryParams);
    return this.execute("GET", `?${params}`).then((res) => res.data);

  }

  getEventsByDate(initDate,endDate){
    return this.execute("GET", `/buscarEventos/${initDate}/${endDate}`).then((res) => res.data);
  }

  searchByStatusOrName(queryParams) {
    return this.execute("GET", `/buscar?${queryParams}`).then((res) => res.data);
  }

  findByName(name) {
    return this.execute("GET", `/nome/${name}`).then((res) => res.data);
  }

  findByNames(name){
    return this.execute("GET", `/nomes?name=${name}`).then((res) => res.data);
  }

  findByNameAndStatus(name, status) {
    return this.execute("GET", `/search?name=${name}&status=${status}`).then((res) => res.data);

  }

  changeStatus(obj) {
    return this.execute("PUT", `/status`, obj);
  }

  sendEventToEmail(obj) {
    return this.execute("POST", `/enviar-email`, obj);
  }
}
